import { IInitialState } from "../context/mapbox-context";

export const mapboxReducer = (state: IInitialState, action: { type: any; payload: any; }) => {
    switch (action.type) {
        case 'SET_MAPBOX_STYLE':
            return { ...state, style: action.payload }
        case 'SET_MENU_SETTINGS':
            return { ...state, isOpenSettings: action.payload }
        case 'SET_STYLE_LAYERS':
            return { ...state, styleLayers: action.payload }
        case 'SET_COORDINATES':
            return { ...state, coordinates: action.payload }
        case 'SET_CLICK_PROPERTIES':
            return { ...state, clickProperties: action.payload }
        case 'SET_MENU_DATA_STATE':
            return { ...state, isOpenDataDrawer: action.payload }
        case 'SET_MENU_FILTER_STATE':
            return { ...state, isOpenFilterDrawer: action.payload }
        case 'SET_LOT_AREA':
            return { ...state, lotArea: action.payload }
        default:
            return state;
    }
}
